export default __webpack_public_path__ + "static/peanut-butter-80b91136a4dd0ffd3a5b1c747796724d.png";